/**
 * @file Observer 全局消息通信观察者
 */

const watchers = {};
export default {
  /**
   * 添加观察者
   * @param {string} key 观察者名称
   * @param {Function} listener 消息接收的事件的指针
   */
  addObserver(key, listener) {
    let watcher = watchers[key];
    if (!watcher) {
      watcher = [];
    }
    for (let i = 0; i < watcher.length; i++) {
      if (listener === watcher[i]) {
        return;
      }
    }
    watcher.push(listener);
    watchers[key] = watcher;
  },
  /**
   * 移除观察者
   * @param {string} key 观察者名称
   * @param {Function} listener 需要删除的事件指针,缺省时会删除指定观察者下的所有消息接收事件
   */
  removeObserver(key, listener) {
    if (!listener) {
      delete watchers[key];
      return;
    }
    let watcher = watchers[key];
    if (!watcher) {
      watcher = [];
    }
    for (let i = 0; i < watcher.length; i++) {
      if (listener !== watcher[i]) {
        continue;
      }
      watcher.splice(i, 1);
      break;
    }
  },
  /**
   * 向指定观察者下所有事件发送通知
   * @param {string} key 观察者名称
   * @param {any} message 发送的内容
   */
  notify(key, message) {
    let watcher = watchers[key];
    if (!watcher) {
      return;
    }
    watcher.forEach(element => {
      setTimeout(() => {
        typeof element === 'function' && element(message);
      }, 0);
    });
  },
  /**
   * 订阅一次
   * @param {string} key 消息主题
   * @param {Function} callback 回调函数
   */
  addOnce(key, callback) {
    function onceFn() {
      typeof callback === 'function' && callback();
      this.removeObserver(key, onceFn);
    }
    this.addObserver(key, onceFn);
  }
};